export default {
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    close: 'Close',
    search: 'Search',
    reset: 'Reset',
    loading: 'Loading...',
    noData: 'No Data',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    required: 'Required',
    optional: 'Optional',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    apply: 'Apply',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    refresh: 'Refresh',
    download: 'Download',
    upload: 'Upload',
    fetchUserInfoFailed: 'Failed to fetch user info',
    view: 'View',
    actions: 'Actions',
    status: 'Status',
    type: 'Type',
    time: 'Time',
    date: 'Date',
    name: 'Name',
    description: 'Description',
    remarks: 'Remarks',
    settings: 'Settings',
    all: 'All',
    total: 'Total',
    items: 'items',
    page: 'Page',
    perPage: 'items/page',
    running: 'Running',
    stopped: 'Stopped',
    starting: 'Starting',
    stopping: 'Stopping',
    day: 'days',
    second: 'seconds',
    and: 'and',
    saveSuccess: 'Saved Successfully',
    deleteSuccess: 'Deleted Successfully',
    operationSuccess: 'Operation Successful',
    operationFailed: 'Operation Failed',
    networkError: 'Network Error',
    errorPage: {
      title: 'Error',
      errorOccurred: 'An Error Occurred',
      unknownError: 'Unknown Error',
      goHome: 'Go to Home',
      goBack: 'Go Back',
      errorDetails: 'Error Details',
      paramParseError: 'Parameter parsing error',
    },
    requestFailed: 'Request Failed',
    pleaseWait: 'Please wait...',
    noPermission: 'No Permission',
    notLoggedIn: 'Please login first',
    redirectToLogin: 'Redirecting to login...',
  },
  moduleMgmt: {
    title: 'Module Management',
    totalModules: 'Total Modules',
    enabled: 'Enabled',
    disabled: 'Disabled',
    viewDisabledModules: 'View Disabled Modules',
    moduleManagement: 'Module Management',
    enableDisableManagement: 'Enable/Disable Management',
    refresh: 'Refresh',
    noModuleInfo: 'No module information',
    moduleName: 'Module Name',
    category: 'Category',
    categoryFile: 'File',
    categoryServer: 'Server',
    categoryP2P: 'P2P',
    categoryProxy: 'Proxy',
    categoryDNS: 'DNS',
    categoryDevice: 'Device',
    status: 'Status',
    dependency: 'Dependency',
    details: 'Details',
    enable: 'Enable',
    disable: 'Disable',
    moduleDetails: 'Module Details',
    name: 'Name',
    description: 'Description',
    version: 'Version',
    running: 'Running',
    notEnabled: 'Disabled',
    noDependency: 'None',
    dependsOn: 'Depends on',
    dependedBy: 'Depended by',
    dependencySatisfied: 'Dependency satisfied',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    disabledModuleList: 'Disabled Module List',
    noDisabledModules: 'No disabled modules',
    error: 'Error',
    action: 'Action',
  },
  p2pClientSettings: {
    title: 'P2P Settings',
    basicSettings: 'P2P Basic Settings',
    clientLabel: 'Client',
    viewLogs: 'View Logs',
    stop: 'Stop',
    editConfig: 'Edit Config',
    name: 'Name',
    serverAddress: 'Server Address',
    secretKey: 'Secret Key',
    secondKey: 'Second Key',
    enableRelay: 'Enable Relay',
    enabled: 'Enabled',
    disabled: 'Disabled',
    exportPort: 'Export Port',
    status: 'Status',
    nodeInfo: 'P2P Node Info',
    localNatType: 'Local NAT Type',
    localConnectAddr: 'Local Connect Address',
    peerNatType: 'Peer NAT Type',
    peerAddr: 'Peer Address',
    peerStatus: 'Status',
    portMapping: 'P2P Port Mapping',
    addMapping: 'Add Mapping',
    stopAll: 'Stop All',
    restartAll: 'Restart All',
    loading: 'Loading...',
    noMapping: 'No Port Mapping Config',
    mappingName: 'Name',
    localPort: 'Local Port',
    peerIP: 'Peer IP',
    peerPort: 'Peer Port',
    protocol: 'Protocol',
    operation: 'Operation',
    start: 'Start',
    edit: 'Edit',
    delete: 'Delete',
    addNewMapping: 'Add Port Mapping',
    editMapping: 'Edit Port Mapping',
    localPortPlaceholder: '1-65535',
    peerIpPlaceholder: 'e.g: 127.0.0.1',
    selectProtocol: 'Select Protocol',
    cancel: 'Cancel',
    save: 'Save',
    editClientConfig: 'Edit P2P Client Config',
    clientNamePlaceholder: 'Client Name',
    secretKeyPlaceholder: '3-20 characters',
    optional: 'Optional',
    selectEnable: 'Select',
    saveAndStart: 'Save and Start',
    runningLogs: 'Running Logs',
    totalLogs: 'Total {count} logs',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    downloadAllLogs: 'Download All Logs',
    refreshNow: 'Refresh Now',
    clearLogs: 'Clear Logs',
    close: 'Close',
    noLogs: 'No Logs',
    confirmStopAll: 'Are you sure to stop all mappings?',
    confirmRestartAll: 'Are you sure to restart all mappings?',
    confirmDeleteMapping: 'Are you sure to delete mapping "{name}"?',
    warning: 'Warning',
    confirm: 'Confirm',
    mappingAdded: 'Mapping Added',
    mappingUpdated: 'Mapping Updated',
    mappingDeleted: 'Mapping Deleted',
    mappingStarted: 'Mapping Started',
    mappingStopped: 'Mapping Stopped',
    mappingStoppedAll: 'All Mappings Stopped',
    mappingRestartedAll: 'All Mappings Restarted',
    saveFailed: 'Save Failed',
    operationFailed: 'Operation Failed',
    namePlaceholder: '3-15 characters, numbers or letters only',
    nameFormatError: 'Name must be 3-15 characters, numbers or letters only',
    portRangeError: 'Port range is 1-65535',
    ipFormatError: 'IP address format is incorrect',
    pleaseSelectProtocol: 'Please select protocol',
    nameRequired: 'Please enter name',
    secretKeyRequired: 'Please enter secret key',
    secretKeyFormatError: 'Secret key must be 3-20 characters, numbers or letters only',
    localPortRequired: 'Please enter local port',
    peerIpRequired: 'Please enter peer IP address',
    peerPortRequired: 'Please enter peer port',
    portRequired: 'Please enter port',
    ipRequired: 'Please enter IP address',
    portProtocolRequired: 'Please enter port and protocol',
    clientConfigUpdated: 'Client Config Updated',
    fetchFailed: 'Failed to fetch data',
    updateFailed: 'Update failed',
    updateSuccess: 'Update success',
    stopFailed: 'Stop failed',
    stopSuccess: 'Stop success',
    addFailed: 'Add failed',
    addSuccess: 'Add success',
    startFailed: 'Start failed',
    startSuccess: 'Start success',
    deleteFailed: 'Delete failed',
    deleteSuccess: 'Delete success',
    stopAllFailed: 'Stop all failed',
    stoppedAllSuccess: 'All mappings stopped',
    restartAllFailed: 'Restart all failed',
    restartedAllSuccess: 'All mappings restarted',
    pleaseSelectServer: 'Please select server first!',
    autoRefreshEnabled: 'Auto refresh enabled (5s/interval)',
    autoRefreshDisabled: 'Auto refresh disabled',
    fetchLogsFailed: 'Failed to fetch logs',
    fetchLogsError: 'Failed to fetch logs',
    confirmClearLogs: 'Are you sure to clear all P2P client logs?',
    clearLogsFailed: 'Failed to clear logs',
    logsCleared: 'Logs cleared',
  },
  nav: {
    userLogin: 'User Login',
    sysHome: 'Home',
    transferServer: 'Transfer Server',
    distributionServer: 'Distribution Server',
    officialClient: 'Control Server',
    officialServer: 'Control Server',
    userConfig: 'User Config',
    fileManagement: 'File Management',
    fileConfig: 'File Config',
    fileList: 'File List',
    favorites: 'Favorites',
    shareFolder: 'Share Folder',
    collectList: 'Favorites',
    shareLinkList: 'Share Folder',
    networkFileServices: 'Network File Services',
    fileSetting: 'File Config',
    networkFileService: 'Network File Service',
    fileSync: 'File Sync',
    fileSyncMgmt: 'File Sync',
    serverManagement: 'Server Management',
    serverMapping: 'Port Mapping',
    userMgmt: 'User Management',
    userManagement: 'User Management',
    fileMgmt: 'File Management',
    moduleMgmt: 'Module Management',
    p2pManagement: 'P2P Management',
    p2pSetting: 'P2P Settings',
    p2pClient: 'P2P Client',
    proxyManagement: 'Proxy Management',
    proxyMgmt: 'Proxy Management',
    forwardProxy: 'Forward Proxy',
    reverseProxy: 'Reverse Proxy',
    ddnsManagement: 'DDNS Management',
    ddnsSetting: 'DDNS Settings',
    aliyunDdns: 'Aliyun DDNS',
    tencentcloudDdns: 'Tencent Cloud DDNS',
    pubyunDdns: 'Pubyun DDNS',
    namecomDdns: 'NameCom DDNS',
    nameyunDdns: 'NameCom DDNS',
    cloudflareDdns: 'Cloudflare DDNS',
    acmeMgmt: 'ACME Management',
    mountMgmt: 'Mount Management',
    mountSettings: 'Mount Settings',
    deviceCenter: 'Device Center',
    acmeManagement: 'ACME Management',
    moduleManagement: 'Module Management',
    sysSetting: 'System Settings',
    systemSettings: 'System Settings',
    about: 'About',
    legacyEntry: 'Legacy Entry',
    logout: 'Logout ({username})',
    loggedOut: 'Not Logged In',
    logoutButton: 'Logout',
    sysAbout: 'About',
    leftNav: 'Left Navigation',
    topNav: 'Top Navigation',
  },
  login: {
    title: 'User Login',
    username: 'Username',
    password: 'Password',
    login: 'Login',
    loggingIn: 'Logging in...',
    rememberMe: 'Remember Me',
    forgotPassword: 'Forgot Password',
    securePath: 'Secure Path',
    syncLogin: 'Auto Login',
    loginSuccess: 'Login Successful',
    loginFailed: 'Login Failed',
    passwordError: 'Incorrect username or password',
    userNotExist: 'User does not exist',
    usernameEmpty: 'Username is empty',
    passwordEmpty: 'Password is empty',
    autoLoginSuccess: 'Auto login successful',
    networkError: 'Network error, please check connection',
    requestError: 'Request configuration error',
    defaultCredentials: 'Default Account Info',
    defaultUsername: 'Username: admin',
    defaultPassword: 'Password: tf12345678',
    changePasswordTip: 'Note: This is the default account. Please change username or password immediately via "User Management -> User Settings"',
    clickToView: 'account',
    clickToViewTip: 'Click to view default account info',
    viewTip: 'to view',
    defaultAccountTip: 'Tip',
    resetPasswordTip: 'Please contact system administrator to reset password',
    captchaError: 'Incorrect captcha',
    usernameLength: 'Username must be 1-20 characters',
    passwordLength: 'Password must be 1-20 characters',
  },
  home: {
    welcome: 'Welcome',
    overview: 'Overview',
    systemStatus: 'System Status',
    quickActions: 'Quick Actions',
    recentActivity: 'Recent Activity',
    diskUsage: 'Disk Usage',
    memoryUsage: 'Memory Usage',
    cpuUsage: 'CPU Usage',
    networkTraffic: 'Network Traffic',
    onlineUsers: 'Online Users',
    totalUsers: 'Total Users',
    totalFiles: 'Total Files',
    serviceStatus: 'Service Status',
    uptime: 'Uptime',
  },
  user: {
    title: 'User Management',
    addUser: 'Add User',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    username: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    nickname: 'Nickname',
    email: 'Email',
    telephone: 'Phone',
    role: 'Role',
    roleStatus: 'Status',
    remark: 'Remark',
    createTime: 'Created',
    loginTime: 'Last Login',
    superAdmin: 'Super Admin',
    admin: 'Admin',
    normalUser: 'User',
    active: '激活',
    inactive: '停用',
    passwordRequired: 'Please enter password',
    passwordMinLength: 'Password must be 6-20 characters',
    passwordMismatch: 'Passwords do not match',
    usernameRequired: 'Please enter username',
    usernameLength: 'Username must be 3-20 characters',
    roleRequired: 'Please select role',
    addSuccess: 'User added successfully',
    editSuccess: 'User updated successfully',
    deleteSuccess: 'User deleted successfully',
    deleteConfirm: 'Are you sure to delete user {username}? This action cannot be undone!',
    activate: 'Activate',
    deactivate: 'Deactivate',
    activated: 'Activated',
    deactivated: 'Deactivated',
    viewLogs: 'View Logs',
    changeUsername: 'Change Username',
    modifySuperAdmin: 'Modify Super Admin Username',
    currentUsername: 'Current Username',
    newUsername: 'New Username',
    renameSuccess: 'Username changed successfully, please login again',
    cannotDeleteSuperAdmin: 'Cannot delete super admin',
    passwordEmptyHint: 'Leave empty to keep current password',
    fetchFailed: 'Failed to get user information',
    usernameSameAsCurrent: 'New username cannot be the same as current username',
    userDeactivated: 'User deactivated',
    userActivated: 'User activated',
    activateFailed: 'Failed to activate user',
    deactivateFailed: 'Failed to deactivate user',
    statusUpdateFailed: 'Failed to update user status',
    renameFailed: 'Failed to update username',
    userRenamed: 'Username changed successfully, please login again',
  },
  file: {
    title: 'File Management',
    fileSetting: 'File Settings',
    fileList: 'File List',
    shareLink: 'Share Links',
    myCollections: 'My Collections',
    fileName: 'File Name',
    fileSize: 'Size',
    fileType: 'Type',
    filePath: 'Path',
    modifiedTime: 'Modified',
    name: 'Name',
    type: 'Type',
    path: 'Path',
    open: 'Open',
    upload: 'Upload',
    properties: 'Properties',
    share: 'Share',
    download: 'Download',
    rename: 'Rename',
    move: 'Move',
    copy: 'Copy',
    paste: 'Paste',
    delete: 'Delete',
    newFolder: 'New Folder',
    uploadFile: 'Upload File',
    uploadFolder: 'Upload Folder',
    refresh: 'Refresh',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    inverseSelect: 'Inverse Select',
    pathNavigation: 'Path Navigation',
    fileOrFolder: 'File or Folder',
    fileCount: 'Files',
    folderCount: 'Folders',
    parentFolder: 'Parent Folder',
    rootDirectory: 'Root Directory',
    noFiles: 'Folder is empty',
    folderModal: {
      currentPath: 'Current Path',
      manualInputPath: 'Manual input path',
      enterPathHint: 'Enter directory path, click confirm to use',
      useThisPath: 'Use This Path',
      afterInputHint: 'Press Enter or click "Use This Path" after entering',
      emptyDirectory: 'Current directory is empty',
      selected: 'Selected',
      parentFolder: 'Parent Folder',
    },
    confirmDelete: 'Confirm Delete',
    deleteSelected: 'Delete Selected',
    confirmDeleteMultiple: 'Are you sure to delete {count} selected items?',
    renameTitle: 'Rename',
    enterNewName: 'Enter new name',
    nameCannotBeEmpty: 'Name cannot be empty',
    invalidFileName: 'File name contains invalid characters',
    renameSuccess: 'Rename successful',
    renameFailed: 'Rename failed',
    shareLinkManagement: 'Share Link Management',
    createShareLink: 'Create Share Link',
    shareLinkUrl: 'Share Link URL',
    shareLinkExpiry: 'Expiry',
    shareLinkPassword: 'Password',
    copyLink: 'Copy Link',
    linkCopied: 'Link copied',
    neverExpiry: 'Never',
    oneDay: '1 Day',
    sevenDays: '7 Days',
    thirtyDays: '30 Days',
    customExpiry: 'Custom',
    shareLinkCreated: 'Share link created successfully',
    cancelShare: 'Cancel Share',
    shareCancelled: 'Share cancelled',
    newFile: 'New File',
    newFilePlaceholder: 'Enter file name (with extension)',
    newFolderPlaceholder: 'Enter folder name',
    defaultNewFileName: 'New File.txt',
    shareLinkList: 'Share Folder',
    linkPrefix: 'Link Prefix',
    modify: 'Modify',
    updateTime: 'Update Time',
    expireTime: 'Expire Time',
    expired: 'Expired',
    size: 'Size',
    deleted: 'Deleted',
    validPeriod: 'Validity',
    days: 'days',
    password: 'Password',
    canUpload: 'Uploadable',
    sharer: 'Sharer',
    start: 'Start',
    stop: 'Stop',
    edit: 'Edit',
    copyLinkLabel: 'Copy Link',
    fileAttribute: 'File Attribute',
    validDays: 'Valid Days',
    none: 'None',
    downloadPassword: 'Download Password',
    operation: 'Operation',
    updateShareLink: 'Update Share Link',
    validity: 'Validity',
    longTerm: 'Long Term',
    custom: 'Custom',
    inputValidDays: 'Enter validity days',
    leaveEmptyNoPassword: 'Leave empty for no password',
    uploadable: 'Uploadable',
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    confirm: 'Confirm',
    modifyShareLinkPrefix: 'Modify Share Link Prefix',
    linkPrefixLabel: 'Link Prefix',
    inputShareLinkPrefix: 'Please enter share link prefix',
    prompt: 'Prompt',
    objectDeleted: 'Object has been deleted',
    updateShareLinkPrefixFailed: 'Failed to update share link prefix',
    updateSuccess: 'Update successful',
    passwordLengthInvalid: 'Password length must be 2-64 characters or empty',
    updateShareLinkFailed: 'Failed to update share link',
    fetchShareLinkFailed: 'Failed to fetch share links',
    pleaseLoginFirst: 'Please login first',
    startShareLinkFailed: 'Failed to start share link',
    startSuccess: 'Start successful',
    stopShareLinkFailed: 'Failed to stop share link',
    stopSuccess: 'Stop successful',
    confirmDeleteShareLink: 'Are you sure to delete share link "{name}"?',
    deleteShareLinkFailed: 'Failed to delete share link',
    deleteSuccess: 'Delete successful',
    linkMayBeOld: 'This link may be outdated due to online editing. You can download the latest content via online preview',
    linkCopiedToClipboard: 'Link copied to clipboard',
    copyFailed: 'Copy failed',
    pleaseManualCopy: 'Please copy manually',
    folder: 'Folder',
    image: 'Image',
    wordDocument: 'Word Document',
    excelDocument: 'Excel Document',
    pptDocument: 'PPT Document',
    pdfDocument: 'PDF Document',
    textFile: 'Text File',
    compressedFile: 'Archive',
    videoFile: 'Video',
    audioFile: 'Audio',
    unknownFile: 'File',
    modifiedDate: 'Modified Date',
    allowUpload: 'Allow Upload',
    collect: 'Collect',
    cut: 'Cut',
    imageLoadFailed: 'Image load failed',
    imageLoading: 'Image loading...',
    noSearchResults: 'No search results',
    searching: 'Searching...',
    tryOtherKeywords: 'Try other keywords',
    fileManagement: {
      webFileService: 'Web File Service',
      networkFileService: 'Network File Service',
      onlineEditSetting: 'Online Edit Settings',
      onlineEditHint: 'OnlyOffice Config',
      officeAddress: 'Online Office Address',
      officeIp: 'Office IP',
      operation: 'Operation',
      officeUrlPlaceholder: 'http://[ip:port]/web-apps/apps/api/documents/api.js',
      enable: 'Enable',
      update: 'Update',
      close: 'Close',
      editableExtensions: 'Editable Extensions',
      readonlyExtensions: 'Read-only Extensions',
      selectOrInputExtensions: 'Select or input extensions',
      directoryList: 'Directory List (created via user management)',
      viewLogs: 'View Logs',
      refreshData: 'Refresh Data',
      username: 'Username',
      status: 'Status',
      directory: 'Directory',
      readonly: 'Read-only',
      delete: 'Delete',
      space: 'Space',
      actions: 'Actions',
      activated: 'Activated',
      notActivated: 'Not Activated',
      addDirectory: '+ Add Directory',
      save: 'Save',
      deactivate: 'Deactivate',
      activate: 'Activate',
      removeDirectory: 'Remove Directory',
      yes: 'Yes',
      no: 'No',
      forbidden: 'Forbidden',
      allowed: 'Allowed',
      clickToApply: 'Click save to apply',
      processing: 'Processing...',
      start: 'Start',
      stop: 'Stop',
      running: 'Running',
      stopped: 'Stopped',
      parentFolder: 'Parent Folder',
      manualInputPath: 'Manual input path (optional)',
      pleaseLoginFirst: 'Please login first',
      autoRefreshEnabled: 'Auto refresh enabled (5s)',
      autoRefreshDisabled: 'Auto refresh disabled',
      networkError: 'Network request failed',
      fetchLogsFailed: 'Failed to fetch logs',
      unknownError: 'Unknown error',
      fetchLogsError: 'Failed to fetch logs: {error}',
      confirmClearLogs: 'Clear all file management logs?',
      clearLogsFailed: 'Failed to clear logs',
      logsCleared: 'Logs cleared',
      noLogsToDownload: 'No logs to download',
      downloadLogsFailed: 'Failed to download logs: {error}',
      downloadLogsSuccess: 'All logs downloaded, {count} records',
      fetchDataFailed: 'Failed to fetch data',
      fetchSettingsFailed: 'Failed to fetch settings',
      pleaseLogin: 'Please login',
      updateFileSettingFailed: 'Failed to update file settings',
      fileSettingUpdated: 'File settings updated',
      updateOfficeAttrFailed: 'Failed to update file attributes',
      officeAttrUpdated: 'File attributes updated',
      extensionsCannotBeEmpty: 'Editable and read-only extensions cannot both be empty',
      operationFailed: 'Operation failed',
      webServiceStarted: 'Web service started',
      webServiceStopped: 'Web service stopped',
      stopUserFailed: 'Failed to stop user',
      userStopped: 'User {username} stopped',
      pleaseAddDirectoryFirst: 'Please add at least one directory',
      configSaveSuccess: 'Config saved successfully',
      saveFailed: 'Save failed',
      saveConfigError: 'Save failed: {error}',
      directoryRemoved: 'Directory {path} removed, click save to apply',
      fetchDirectoryListFailed: 'Failed to fetch directory list',
      pleaseInputDirectoryPath: 'Please enter directory path',
      directorySelected: 'Selected directory: {path}, click confirm to save',
      pleaseSelectDirectory: 'Please select directory',
      directoryAlreadyExists: 'Directory already exists',
      directoryAdded: 'Directory {path} added',
      mobileUsername: 'Username',
      mobileStatus: 'Status',
      mobileDirectory: 'Directory',
      mobileOperation: 'Operation',
      mobileReadonly: 'Read-only',
      mobileDelete: 'Delete',
      mobileSpace: 'Space',
      noLogRecords: 'No log records',
    },
  },
  networkFile: {
    title: 'Network File Services',
    webdav: 'WebDAV (/tfdav)',
    webdavHttps: 'HTTPS WebDAV',
    webdavHttp: 'HTTP WebDAV',
    smb: 'SMB File Sharing',
    sftp: 'SFTP Service',
    sftpComing: 'Coming Soon',
    port: 'Port',
    workgroup: 'Workgroup',
    running: 'Running',
    stopped: 'Stopped',
    processing: 'Processing...',
    save: 'Save',
    start: 'Start',
    stop: 'Stop',
    startService: 'Start Service',
    stopService: 'Stop Service',
    serviceStarted: 'Service started',
    serviceStopped: 'Service stopped',
    portSaved: 'Port saved',
    configSaved: 'Configuration saved',
    portAlreadyInUse: 'Port already in use',
    viewLogs: 'View Logs',
    webdavModule: 'WebDAV',
    smbModule: 'SMB',
    logTitle: 'Network File Services Operation Logs',
    totalLogs: 'Total {count} logs',
    selectModule: 'Select Module',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    downloadAllLogs: 'Download All Logs',
    refreshNow: 'Refresh Now',
    clearLogs: 'Clear Logs',
    noLogs: 'No Logs',
    operationFailed: 'Operation failed',
    saveFailed: 'Save failed',
    httpsPortSaved: 'HTTPS port saved',
    httpPortSaved: 'HTTP port saved',
    smbPortSaved: 'SMB port saved',
    pleaseLoginFirst: 'Please login first',
    networkFileServicesLog: 'Network File Services Log',
    close: 'Close',
  },
  mount: {
    title: 'Mount Management',
    dependencyPackage: 'Dependency Package',
    packageInfo: 'Package',
    systemInfo: 'System Info',
    status: 'Status',
    installed: 'Installed',
    notInstalled: 'Not Installed',
    winfspDownload: 'Download WinFSP',
    mountList: 'Mount List',
    viewLog: 'View Logs',
    add: 'Add',
    operationGuide: 'Operation Guide',
    runningAsNonAdmin: 'Running as non-admin',
    runningAsAdmin: 'Running as admin',
    runningAsNonAdminNote: '(Note: Some software may not run in mounted drives)',
    noMountList: 'No mount list',
    stop: 'Stop',
    open: 'Open',
    log: 'Log',
    start: 'Start',
    edit: 'Edit',
    delete: 'Delete',
    unmounted: 'Unnamed',
    networkDrive: 'Network Drive',
    localDrive: 'Local Drive',
    addMount: 'Add Mount',
    editMount: 'Edit Mount',
    name: 'Name',
    mountName: 'Mount Name',
    mountPoint: 'Mount Point',
    webdavAddress: 'WebDAV Address',
    username: 'Username',
    password: 'Password',
    method: 'Method',
    mode: 'Mode',
    cancel: 'Cancel',
    save: 'Save',
    tfcenter: 'tfcenter',
    rclone: 'rclone',
    linuxOnlyRclone: '(Linux can only use rclone method)',
    leaveEmptyToKeepPassword: 'Leave empty to keep current password',
    logContent: 'Log Content - ',
    logSize: 'Log Size:',
    refreshLog: 'Refresh Log',
    downloadLog: 'Download Log',
    noLogContent: 'No log content',
    close: 'Close',
    runningLog: 'Running Log',
    totalLogs: 'Total {count} logs',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    downloadAllLogs: 'Download All Logs',
    refreshNow: 'Refresh Now',
    clearLogs: 'Clear Logs',
    noLogRecords: 'No log records',
    confirmClearLogs: 'Are you sure to clear all WebDAV module logs?',
    warning: 'Warning',
    autoRefreshEnabled: 'Auto refresh enabled (5s/interval)',
    autoRefreshDisabled: 'Auto refresh disabled',
    confirmDeleteMount: 'Are you sure to delete mount {name}?',
    pleaseLoginFirst: 'Please login first',
    fetchLogFailed: 'Failed to fetch log',
    fetchLogContentFailed: 'Failed to fetch log content: {error}',
    logRefreshed: 'Log refreshed',
    noLogToDownload: 'No log to download',
    logDownloadSuccess: 'Log downloaded successfully',
    logDownloadFailed: 'Failed to download log: {error}',
    clearLogFailed: 'Failed to clear logs: {error}',
    logsCleared: 'Logs cleared',
    noLogsToDownload: 'No logs to download',
    allLogsDownloadSuccess: 'All logs downloaded successfully, {count} records',
    logsDownloadFailed: 'Failed to download logs: {error}',
    addFailed: 'Add failed',
    startFailed: 'Start failed',
    updateFailed: 'Update failed',
    deleteFailed: 'Delete failed',
    stopFailed: 'Stop failed',
    fetchMountListFailed: 'Failed to fetch mount list: {error}',
    cannotOpenFolderManually: 'Cannot open folder automatically, please access manually:',
    clickConfirmToCopyPath: 'Click confirm to copy path',
    copyCanceledOrFailed: 'Copy canceled or failed',
    nameRequired: 'Name is required',
    nameFormatError: 'Name must be 3-15 characters, numbers or letters only',
    mountPointRequired: 'Mount point is required',
    webdavAddressRequired: 'WebDAV address is required',
    usernameRequired: 'Username is required',
    passwordRequired: 'Password is required',
    passwordLengthError: 'Password must be 2-64 characters',
    pleaseSelectMethod: 'Please select mount method',
    pleaseSelectMode: 'Please select mount mode',
    namePlaceholder: '3-15 characters, numbers or letters only',
    mountNamePlaceholder: 'Mount name (optional)',
    mountPointPlaceholder: 'Mount point',
    webdavAddressPlaceholder: 'WebDAV address',
    usernamePlaceholder: 'Username',
    passwordPlaceholder: 'Password',
    networkError: 'Network request failed',
    unknownError: 'Unknown error',
  },
  device: {
    title: 'Device Center',
    subtitle: 'Manage all connected device information',
    deviceList: 'Device List',
    deviceName: 'Device Name',
    deviceType: 'Device Type',
    deviceStatus: 'Device Status',
    online: 'Online',
    offline: 'Offline',
    lastSeen: 'Last Seen',
    deviceId: 'Device ID',
    addDevice: 'Add Device',
    editDevice: 'Edit Device',
    deleteDevice: 'Delete Device',
    deviceInfo: 'Device Info',
    viewLogs: 'View Logs',
    totalDevices: 'Total Devices',
    onlineDevices: 'Online Devices',
    offlineDevices: 'Offline Devices',
    searchPlaceholder: 'Search device name or address...',
    noDevices: 'No Devices',
    noDevicesHint: 'Click "Add Device" button to add your first device',
    address: 'Address',
    securePath: 'Secure Path',
    remark: 'Remark',
    index: 'Index',
    connectDevice: 'Connect Device',
    edit: 'Edit',
    delete: 'Delete',
    deviceNameRequired: 'Device name is required',
    deviceAddrRequired: 'Device address is required',
    addDeviceTitle: 'Add Device',
    editDeviceTitle: 'Edit Device',
    deviceNameLabel: 'Device Name *',
    deviceNamePlaceholder: 'Please enter device name',
    deviceAddrLabel: 'Device Address *',
    deviceAddrPlaceholder: 'e.g: http://192.168.1.100:8080',
    securePathLabel: 'Secure Path',
    securePathPlaceholder: 'Please enter secure path (optional)',
    remarkLabel: 'Remark',
    remarkPlaceholder: 'Please enter device remark (optional)',
    cancel: 'Cancel',
    saving: 'Saving...',
    updateDevice: 'Update Device',
    addDeviceAction: 'Add Device',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMsg: 'Are you sure you want to delete device "{name}"?',
    operationUndone: 'This operation cannot be undone!',
    deleting: 'Deleting...',
    confirmDeleteAction: 'Confirm Delete',
    operationLogs: 'Operation Logs',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    totalLogs: 'Total {count} logs',
    downloading: 'Downloading...',
    downloadAllLogs: '📥 Download All Logs',
    refreshing: 'Refreshing...',
    refreshNow: '🔄 Refresh Now',
    clearing: 'Clearing...',
    clearLogs: '🗑️ Clear Logs',
    noLogs: 'No Log Records',
    close: 'Close',
    logsCleared: 'Logs cleared',
    logsClearFailed: 'Failed to clear logs: {error}',
    fetchLogsFailed: 'Failed to fetch logs',
    noLogsToDownload: 'No logs to download',
    logsDownloadSuccess: 'All logs downloaded successfully, {count} entries',
    logsDownloadFailed: 'Failed to download logs: {error}',
    loginRequired: 'Please login first',
    loginRequiredRedirect: 'Please login first',
    networkError: 'Network request failed',
    fetchDeviceListFailed: 'Failed to fetch device list',
    fetchDeviceListFailedRetry: 'Failed to fetch device list, please check network connection',
    saveDeviceFailed: 'Failed to save device',
    saveDeviceFailedRetry: 'Failed to save device, please check network connection',
    deviceUpdateSuccess: 'Device updated successfully',
    deviceAddSuccess: 'Device added successfully',
    deviceUpdateFailed: 'Failed to update device',
    deviceAddFailed: 'Failed to add device',
    deviceDeleteSuccess: 'Device deleted successfully',
    deviceDeleteFailed: 'Failed to delete device',
    deviceDeleteFailedRetry: 'Failed to delete device, please check network connection',
    deviceAddrEmpty: 'Device address cannot be empty',
    popupBlocked: 'Popup may be blocked by browser, please check browser settings or try copying the address manually',
    addressCopied: 'Address copied to clipboard: {address}',
    copyAddressFailed: 'Failed to copy address',
    openingDevicePage: 'Opening device connection page...',
    openDevicePageFailed: 'Failed to open device page: {error}',
    autoRefreshEnabled: 'Auto refresh enabled (5s/interval)',
    autoRefreshDisabled: 'Auto refresh disabled',
    clearLogsConfirm: 'Are you sure you want to clear all device center logs?',
    logsPerPage: '{count} items/page',
    selectLogSize: 'Select log size',
  },
  mapping: {
    title: 'Port Mapping',
    addMapping: 'Add Mapping',
    editMapping: 'Edit Mapping',
    deleteMapping: 'Delete Mapping',
    internalPort: 'Internal Port',
    externalPort: 'External Port',
    protocol: 'Protocol',
    tcp: 'TCP',
    udp: 'UDP',
    both: 'TCP/UDP',
    mappingStatus: 'Mapping Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    enable: 'Enable',
    disable: 'Disable',
    enableSuccess: 'Mapping enabled',
    disableSuccess: 'Mapping disabled',
  },
  tunnel: {
    title: 'Tunnel Management',
    addTunnel: 'Add Tunnel',
    editTunnel: 'Edit Tunnel',
    deleteTunnel: 'Delete Tunnel',
    tunnelName: 'Tunnel Name',
    tunnelType: 'Tunnel Type',
    tunnelStatus: 'Tunnel Status',
    localPort: 'Local Port',
    remotePort: 'Remote Port',
    tunnelServer: 'Tunnel Server',
    connected: 'Connected',
    disconnected: 'Disconnected',
    connect: 'Connect',
    disconnect: 'Disconnect',
    connectSuccess: 'Tunnel connected',
    disconnectSuccess: 'Tunnel disconnected',
  },
  homePage: {
    systemMonitorPanel: 'System Monitor Panel',
    lastUpdate: 'Last Update',
    refreshing: 'Refreshing...',
    manualRefresh: 'Manual Refresh',
    viewLogs: 'View Logs',
    systemInfo: 'System Info',
    hostName: 'Host Name',
    cpuUsage: 'CPU Usage',
    memoryUsage: 'Memory Usage',
    networkSpeed: 'Network Speed',
    systemTime: 'System Time',
    disk: 'Disk',
    softwareInfo: 'Software Info',
    softwareVersion: 'Software Version',
    cpuUsageShort: 'CPU',
    memoryUsageShort: 'Memory',
    goroutineCount: 'Goroutines',
    startTime: 'Start Time',
    runningTime: 'Running Time',
    runningLogs: 'Running Logs',
    totalLogs: '{count} logs',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    downloadAllLogs: 'Download All Logs',
    refreshNow: 'Refresh Now',
    clearLogs: 'Clear Logs',
    noLogs: 'No logs yet',
    confirmClearLogs: 'Are you sure you want to clear all system monitor logs?',
    logsCleared: 'Logs cleared',
    noLogsToDownload: 'No logs to download',
    downloadSuccess: 'Logs downloaded successfully, {count} records',
    pleaseLoginFirst: 'Please login first',
    fetchInfoFailed: 'Failed to fetch home info',
    networkError: 'Network error',
    clearError: 'Failed to clear logs',
    downloadError: 'Failed to download logs',
    autoRefreshEnabled: 'Auto refresh enabled (5s)',
    autoRefreshDisabled: 'Auto refresh disabled',
    close: 'Close',
  },
  dns: {
    title: 'DNS Management',
    addDns: 'Add DNS',
    editDns: 'Edit DNS',
    deleteDns: 'Delete DNS',
    dnsProvider: 'DNS Provider',
    domain: 'Domain',
    recordType: 'Record Type',
    recordValue: 'Record Value',
    ttl: 'TTL',
    dnsStatus: 'Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    enable: 'Enable',
    disable: 'Disable',
    aliDns: 'Aliyun DNS',
    cloudflare: 'Cloudflare',
    tencentCloud: 'Tencent Cloud DNS',
    nameYun: 'NameYun DNS',
    puYun: 'PuYun DNS',
    accessKey: 'Access Key',
    secretKey: 'Secret Key',
  },
  ddnsSetting: {
    title: 'Basic Settings',
    basicSettings: 'Basic Settings',
    publicIpCheckCycle: 'Public IP Check Cycle',
    cycle: 'Cycle',
    checkCycle: 'Check Cycle',
    seconds: 'Seconds',
    status: 'Status',
    running: 'Running',
    stopped: 'Stopped',
    startService: 'Start Service',
    stopService: 'Stop Service',
    edit: 'Edit',
    modifyCheckCycle: 'Modify Check Cycle',
    inputCheckCycle: 'Enter a number between 1-99999',
    save: 'Save',
    cancel: 'Cancel',
    confirmStart: 'Are you sure you want to start the check service?',
    confirmStop: 'Are you sure you want to stop the check service?',
    serviceStarted: 'Check service started',
    serviceStopped: 'Check service stopped',
    startFailed: 'Failed to start service',
    stopFailed: 'Failed to stop service',
    fetchFailed: 'Failed to fetch data',
    getSettingsFailed: 'Failed to get settings',
    updateFailed: 'Failed to update',
    updateSuccess: 'Updated successfully',
  },
  ddns: {
    title: 'Dynamic DNS',
    addDdns: 'Add DDNS',
    editDdns: 'Edit DDNS',
    deleteDdns: 'Delete DDNS',
    domain: 'Domain',
    ipAddress: 'IP Address',
    lastUpdate: 'Last Update',
    updateInterval: 'Update Interval',
    updateNow: 'Update Now',
    updateSuccess: 'Update successful',
    updateFailed: 'Update failed',
    autoUpdate: 'Auto Update',
    aliyunAccessKey: 'Aliyun Access Key',
    editKey: 'Edit Key',
    accessKeyId: 'AccessKey ID',
    accessKeySecret: 'AccessKey Secret',
    notConfigured: 'Not configured',
    ddnsList: 'DDNS List',
    serviceEnabled: 'Service Enabled',
    serviceDisabled: 'Service Disabled',
    viewLogs: 'View Logs',
    addRecord: 'Add Record',
    noDdnsRecords: 'No DDNS records',
    name: 'Name',
    prefix: 'Prefix',
    domainName: 'Domain',
    type: 'Type',
    ipType: 'IP Acquisition',
    mappedIp: 'Mapped IP',
    backupIp: 'Backup IP',
    status: 'Status',
    actions: 'Actions',
    deactivate: 'Deactivate',
    activate: 'Activate',
    delete: 'Delete',
    edit: 'Edit',
    editAliyunAccessKey: 'Edit Aliyun Access Key',
    inputAccessKeyId: 'Please enter Aliyun AccessKey ID',
    inputAccessKeySecret: 'Please enter Aliyun AccessKey Secret',
    ipv4: 'IPv4',
    ipv6: 'IPv6',
    ipv4Record: 'IPv4 (A record)',
    ipv6Record: 'IPv6 (AAAA record)',
    autoGet: 'Auto Get',
    custom: 'Custom',
    saveKey: 'Save Key',
    editDnsRecord: 'Edit DNS Record',
    addDnsRecord: 'Add DNS Record',
    save: 'Save',
    update: 'Update',
    operationLogs: 'Operation Logs',
    totalLogs: '{count} log entries',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    downloadAllLogs: 'Download All Logs',
    refreshNow: 'Refresh Now',
    clearLogs: 'Clear Logs',
    noLogRecords: 'No log records',
    close: 'Close',
    recordName: 'Record Name',
    inputRecordName: 'Please enter record name',
    recordPrefix: 'Record Prefix',
    inputPrefix: 'e.g: www, , *',
    inputDomain: 'e.g: example.com',
    recordType: 'Record Type',
    selectRecordType: 'Please select record type',
    selectIpMethod: 'Please select IP acquisition method',
    inputIpAddress: 'Please enter IP address',
    autoGetting: 'Auto getting...',
    backupIpAddress: 'Backup IP Address',
    inputBackupIp: 'Please enter backup IP address (optional)',
    confirmDeleteDns: 'Are you sure to delete this DNS record?',
    confirmClearLogs: 'Are you sure to clear all Aliyun DDNS logs?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    networkError: 'Network request failed',
    saveFailed: 'Save failed',
    aliyunKeySaveSuccess: 'Aliyun key saved successfully',
    aliyunKeySaveFailed: 'Failed to save Aliyun key',
    dnsRecordSaveSuccess: 'DNS record saved successfully',
    dnsRecordSaveFailed: 'Failed to save DNS record',
    dnsRecordActivateSuccess: 'DNS record activated',
    dnsRecordActivateFailed: 'Failed to activate DNS record',
    dnsRecordDeactivateSuccess: 'DNS record deactivated',
    dnsRecordDeactivateFailed: 'Failed to deactivate DNS record',
    dnsRecordDeleteSuccess: 'DNS record deleted successfully',
    dnsRecordDeleteFailed: 'Failed to delete DNS record',
    autoRefreshEnabled: 'Auto refresh enabled (5s interval)',
    autoRefreshDisabled: 'Auto refresh disabled',
    getLogsFailed: 'Failed to get logs',
    logsCleared: 'Logs cleared',
    logsClearFailed: 'Failed to clear logs',
    noLogsToDownload: 'No logs to download',
    logsDownloadSuccess: 'All logs downloaded successfully, {count} entries',
    logsDownloadFailed: 'Failed to download logs',
    getDataFailed: 'Failed to get data',
    loginRequired: 'Please login first',
    invalidIpv4: 'Please enter a valid IPv4 address',
    invalidIpv6: 'Please enter a valid IPv6 address',
    invalidRecordName: 'Name can only contain letters, numbers, underscores and hyphens',
    invalidDomain: 'Please enter a valid domain',
    unknownStatus: 'Unknown status',
    activeSuccess: 'Success',
    activateSuccess: 'Activate Success',
    activeFailed: 'Failed',
    activeError: 'Error',
    inactive: 'Inactive',
    closed: 'Closed',
    multipleMappings: 'Multiple mappings exist',
    tencentAccessKey: 'Tencent Cloud Access Key',
    tencentSecretId: 'SecretId',
    tencentSecretKey: 'SecretKey',
    secretId: 'SecretId',
    secretKey: 'SecretKey',
    editTencentAccessKey: 'Edit Tencent Cloud Access Key',
    inputSecretId: 'Please enter SecretId',
    inputSecretKey: 'Please enter SecretKey',
    tencentKeySaveSuccess: 'Tencent Cloud key saved successfully',
    tencentKeySaveFailed: 'Failed to save Tencent Cloud key',
    dnsRecordTencentSaveSuccess: 'DNS record saved successfully',
    dnsRecordTencentSaveFailed: 'Failed to save DNS record',
    dnsRecordDeleteConfirm: 'Are you sure to delete this DNS record?',
    dnsRecordDeleteTencentSuccess: 'DNS record deleted successfully',
    dnsRecordDeleteTencentFailed: 'Failed to delete DNS record',
    confirmClearTencentLogs: 'Are you sure to clear all Tencent Cloud DDNS logs?',
    globalDisabled: 'Global Disabled',
    refreshIntervalSeconds: '(5s)',
    tencentcloudLogsDownloadSuccess: 'All logs downloaded successfully, {count} entries',
  },
  proxy: {
    title: 'Proxy Service',
    httpProxy: 'HTTP Proxy',
    socks5Proxy: 'SOCKS5 Proxy',
    proxyPort: 'Proxy Port',
    proxyStatus: 'Proxy Status',
    running: 'Running',
    stopped: 'Stopped',
    start: 'Start',
    stop: 'Stop',
    startProxy: 'Start Proxy',
    stopProxy: 'Stop Proxy',
    proxyStarted: 'Proxy started',
    proxyStopped: 'Proxy stopped',
  },
  fileSync: {
    title: 'Sync Service (One-way Sync)',
    globalSyncService: 'Sync Service (One-way Sync)',
    wifiSyncService: 'WiFi Sync Only (Current Network: {network})',
    enabled: 'Enabled',
    disabled: 'Disabled',
    opening: 'Processing...',
    open: 'Open',
    close: 'Close',
    closeService: 'Close Service',
    openService: 'Open Service',
    closeWiFiSync: 'Close WiFi Sync',
    openWiFiSync: 'Open WiFi Sync',
    syncList: 'Sync List',
    viewLogs: 'View Logs',
    addTask: 'Add Task',
    name: 'Name',
    localPath: 'Local Path',
    remoteAddr: 'Remote Address',
    remotePath: 'Remote Path',
    remoteUsername: 'Remote Username',
    scanPeriod: 'Scan Period(s)',
    syncMethod: 'Sync Method',
    status: 'Status',
    operation: 'Operation',
    stop: 'Stop',
    start: 'Start',
    edit: 'Edit',
    delete: 'Delete',
    currentNetwork: 'Current Network',
    networkLabel: 'Current Network:',
    noTasks: 'No Sync Tasks',
    addNewTask: 'Add Task',
    editTask: 'Edit Task',
    taskName: 'Task Name',
    selectLocalPath: 'Please select local path',
    enterRemoteAddr: 'Please enter remote address',
    enterRemotePath: 'Please enter remote path',
    enterUsername: 'Please enter username',
    enterPassword: 'Please enter password',
    enterScanPeriod: 'Please enter scan period (seconds)',
    selectSyncMethod: 'Please select sync method',
    save: 'Save',
    cancel: 'Cancel',
    syncOnStart: 'Sync on Start',
    deleteConfirm: 'Are you sure to delete this task?',
    warning: 'Warning',
    confirm: 'Confirm',
    taskAdded: 'Task Added',
    taskUpdated: 'Task Updated',
    taskDeleted: 'Task Deleted',
    taskStarted: 'Task Started',
    taskStopped: 'Task Stopped',
    operationFailed: 'Operation Failed',
    addFailed: 'Add Failed',
    updateFailed: 'Update Failed',
    deleteFailed: 'Delete Failed',
    startFailed: 'Start Failed',
    stopFailed: 'Stop Failed',
    runningLogs: 'Running Logs',
    totalLogs: 'Total {count} logs',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    downloadAllLogs: 'Download All Logs',
    refreshNow: 'Refresh Now',
    clearLogs: 'Clear Logs',
    noLogs: 'No Logs',
    confirmClearLogs: 'Are you sure to clear all sync logs?',
    logsCleared: 'Logs Cleared',
    clearFailed: 'Clear Logs Failed',
    downloadFailed: 'Download Logs Failed',
    noLogsToDownload: 'No Logs to Download',
    downloadSuccess: 'Logs downloaded, {count} records',
    syncEnabled: 'Sync Enabled',
    syncDisabled: 'Sync Disabled',
    wifiSyncEnabled: 'WiFi Sync Enabled',
    wifiSyncDisabled: 'WiFi Sync Disabled',
    closeWiFiSyncService: 'Close Only WiFi Sync',
    openWiFiSyncService: 'Open Only WiFi Sync',
    closeServiceButton: 'Close Service',
    openServiceButton: 'Open Service',
    clickToViewNetwork: 'Click to view network',
    network: 'Network',
    viewLogsButton: 'View Logs',
    addTaskButton: 'Add Task',
    runningStatus: 'Running',
    stoppedStatus: 'Stopped',
    taskNamePlaceholder: '3-15 characters, letters and numbers only',
    localPathPlaceholder: 'Please select local path',
    remoteAddrPlaceholder: 'e.g., 192.168.1.100:8080',
    remotePathPlaceholder: 'Remote path',
    usernamePlaceholder: 'Username',
    remotePassword: 'Remote Password',
    leaveEmptyToKeep: 'Leave empty to keep current password',
    scanPeriodPlaceholder: '60',
    select: 'Select',
    show: 'Show',
    hide: 'Hide',
    add: 'Add',
    parentFolder: '← Parent Folder',
    parentFolderMobile: '← Go Back',
    currentPath: 'Current Path',
    manualInputPath: 'Manual input path (optional)',
    manualInputPathMobile: 'Manual input path',
    enterDirectoryPath: 'Please enter directory path',
    emptyDirectory: 'Current directory is empty',
    selected: 'Selected',
    downloading: 'Downloading...',
    refreshing: 'Refreshing...',
    clearing: 'Clearing...',
    perPage: '/page',
    syncLogs: 'File Sync Logs',
    totalLogsMobile: 'Total {count} logs',
    confirmDeleteTask: 'Are you sure to delete {name}?',
    deleteSuccess: 'Deleted successfully',
    addTaskFailed: 'Add task failed',
    updateTaskFailed: 'Update task failed',
    startTaskFailed: 'Start task failed',
    stopTaskFailed: 'Stop task failed',
    fetchDataFailed: 'Failed to fetch data',
    fetchFoldersFailed: 'Failed to fetch folder list',
    fetchLogsFailed: 'Failed to fetch logs',
    fetchLogsFailedDetail: 'Failed to fetch logs: {error}',
    networkError: 'Network error',
    unknownError: 'Unknown error',
    clearLogsFailed: 'Failed to clear logs',
    clearLogsFailedDetail: 'Failed to clear logs: {error}',
    directorySelected: 'Directory selected: {path}, please click confirm to save',
    pleaseSelectDirectory: 'Please select or input directory path',
    autoRefreshEnabled: 'Auto refresh enabled (5s)',
    autoRefreshDisabled: 'Auto refresh disabled',
    downloadLogsFailed: 'Failed to download logs',
    downloadLogsFailedDetail: 'Failed to download logs: {error}',
    addSync: 'Add Sync',
    editSync: 'Edit Sync',
    deleteSync: 'Delete Sync',
    syncTask: 'Sync Task',
    syncMode: 'Sync Mode',
    sourcePath: 'Source Path',
    targetPath: 'Target Path',
    syncDirection: 'Sync Direction',
    upload: 'Upload',
    download: 'Download',
    bidirectional: 'Bidirectional',
    syncStatus: 'Sync Status',
    syncing: 'Syncing',
    synced: 'Synced',
    error: 'Error',
    startSync: 'Start Sync',
    pauseSync: 'Pause Sync',
    syncNow: 'Sync Now',
    lastSync: 'Last Sync',
    nextSync: 'Next Sync',
    syncSuccess: 'Sync successful',
    syncFailed: 'Sync failed',
  },
  p2p: {
    title: 'P2P Connection',
    addPeer: 'Add Peer',
    editPeer: 'Edit Peer',
    deletePeer: 'Delete Peer',
    peerId: 'Peer ID',
    peerName: 'Peer Name',
    peerAddress: 'Peer Address',
    connectionStatus: 'Connection Status',
    connected: 'Connected',
    connecting: 'Connecting',
    disconnected: 'Disconnected',
    connect: 'Connect',
    disconnect: 'Disconnect',
    peerInfo: 'Peer Info',
  },
  pubyunDdns: {
    configTitle: 'PubYun(3322) Configuration',
    editConfig: 'Edit Config',
    username: 'Username',
    password: 'Password',
    notConfigured: 'Not configured',
    ddnsList: 'DDNS List',
    serviceEnabled: 'Service Enabled',
    serviceDisabled: 'Service Disabled',
    viewLogs: 'View Logs',
    addRecord: 'Add Record',
    noRecords: 'No DDNS records',
    name: 'Name',
    domain: 'Domain',
    type: 'Type',
    ipType: 'IP Acquisition',
    mappedIp: 'Mapped IP',
    status: 'Status',
    actions: 'Actions',
    update: 'Update',
    delete: 'Delete',
    cancel: 'Cancel',
    saveConfig: 'Save Config',
    editPubyunConfig: 'Edit PubYun Config',
    inputUsername: 'Please enter PubYun username',
    inputPassword: 'Please enter PubYun password',
    editDnsRecord: 'Edit DNS Record',
    addDnsRecord: 'Add DNS Record',
    recordName: 'Record Name',
    inputRecordName: 'Please enter record name',
    inputDomain: 'e.g: example.3322.org',
    ipv4: 'IPv4',
    ipv6: 'IPv6',
    ipv4Record: 'IPv4 (A record)',
    ipv6Record: 'IPv6 (AAAA record)',
    autoGet: 'Auto Get',
    custom: 'Custom',
    autoGetting: 'Auto getting...',
    title: 'Title',
    logTitle: 'Running Logs',
    alertUpdateInterval: 'Note: The minimum interval between update requests is 1 minute (15 seconds for paid users). If you make more than 3 consecutive frequent requests, the domain will be automatically blocked by the system.',
  },
  nameyunDdns: {
    configTitle: 'NameYun Configuration',
    editConfig: 'Edit Config',
    username: 'Username',
    password: 'Token',
    notConfigured: 'Not configured',
    ddnsList: 'DDNS List',
    serviceEnabled: 'Service Enabled',
    serviceDisabled: 'Service Disabled',
    viewLogs: 'View Logs',
    addRecord: 'Add Record',
    noRecords: 'No DDNS records',
    name: 'Name',
    prefix: 'Prefix',
    domain: 'Domain',
    type: 'Type',
    ipTypeGet: 'IP Acquisition Method',
    mappedIp: 'Mapped IP',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    update: 'Update',
    delete: 'Delete',
    cancel: 'Cancel',
    saveConfig: 'Save Config',
    editNameyunConfig: 'Edit NameYun Config',
    inputUsername: 'Please enter NameYun username',
    inputToken: 'Please enter NameYun Token',
    editDnsRecord: 'Edit DNS Record',
    addDnsRecord: 'Add DNS Record',
    recordName: 'Record Name',
    inputRecordName: 'Please enter record name',
    inputPrefix: 'e.g: www, , *',
    inputDomain: 'e.g: example.com',
    recordType: 'Record Type',
    ipv4: 'IPv4',
    ipv6: 'IPv6',
    ipv4Record: 'IPv4 (A record)',
    ipv6Record: 'IPv6 (AAAA record)',
    autoGet: 'Auto Get',
    custom: 'Custom',
    ipAddress: 'IP Address',
    autoGetting: 'Auto getting...',
    inputIpAddress: 'Please enter IP address',
    globalDisabled: 'Global Disabled',
    logTitle: 'Running Logs',
    totalLogs: 'Total {count} logs',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    downloadAllLogs: 'Download All Logs',
    refreshNow: 'Refresh Now',
    clearLogs: 'Clear Logs',
    noLogs: 'No log records',
    close: 'Close',
  },
  cloudflareDdns: {
    configTitle: 'Cloudflare Configuration',
    editConfig: 'Edit Config',
    configKeyId: 'ZoneID',
    configToken: 'Token',
    notConfigured: 'Not configured',
    ddnsList: 'DDNS List',
    serviceEnabled: 'Service Enabled',
    serviceDisabled: 'Service Disabled',
    viewLogs: 'View Logs',
    addRecord: 'Add Record',
    noRecords: 'No DDNS records',
    name: 'Name',
    prefix: 'Prefix',
    domain: 'Domain',
    type: 'Type',
    ipTypeGet: 'IP Acquisition Method',
    mappedIp: 'Mapped IP',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    update: 'Update',
    delete: 'Delete',
    cancel: 'Cancel',
    saveConfig: 'Save Config',
    editCloudflareConfig: 'Edit Cloudflare Config',
    inputZoneId: 'Please enter ZoneID',
    inputToken: 'Please enter Token',
    editDnsRecord: 'Edit DNS Record',
    addDnsRecord: 'Add DNS Record',
    recordName: 'Record Name',
    inputRecordName: 'Please enter record name',
    inputPrefix: 'e.g: www, , *',
    inputDomain: 'e.g: example.com',
    recordType: 'Record Type',
    ipv4: 'IPv4',
    ipv6: 'IPv6',
    ipv4Record: 'IPv4 (A record)',
    ipv6Record: 'IPv6 (AAAA record)',
    autoGet: 'Auto Get',
    custom: 'Custom',
    ipAddress: 'IP Address',
    autoGetting: 'Auto getting...',
    inputIpAddress: 'Please enter IP address',
    globalDisabled: 'Global Disabled',
    logTitle: 'Running Logs',
    totalLogs: 'Total {count} logs',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    downloadAllLogs: 'Download All Logs',
    refreshNow: 'Refresh Now',
    clearLogs: 'Clear Logs',
    noLogs: 'No log records',
    close: 'Close',
  },
  acmeMgmt: {
    title: 'ACME Certificate Configuration',
    subtitle: 'Certificate Management',
    certMgmt: 'Certificate Management',
    viewLogs: 'View Logs',
    addConfig: 'Add Config',
    noCerts: 'No certificate configuration',
    name: 'Name',
    mainDomain: 'Main Domain',
    subdomains: 'Subdomains',
    provider: 'Provider',
    challengeMethod: 'Verification Method',
    autoRenew: 'Auto Renew',
    certStatus: 'Certificate Status',
    notApplied: 'Not Applied',
    actions: 'Actions',
    apply: 'Apply',
    edit: 'Edit',
    delete: 'Delete',
    editCertConfig: 'Edit Certificate Config',
    addCertConfig: 'Add Certificate Config',
    configName: 'Config Name',
    inputConfigName: 'Please enter unique config name',
    mainDomainLabel: 'Main Domain',
    inputMainDomain: 'example.com',
    subdomainsLabel: 'Subdomains',
    inputSubdomains: 'Enter subdomains, supports wildcards like *.example.com',
    dnsProvider: 'DNS Provider',
    aliyun: 'Aliyun',
    tencent: 'Tencent',
    challengeType: 'Challenge Type',
    dnsChallenge: 'DNS Verification',
    autoRenewal: 'Auto Renewal',
    enabled: 'Enabled',
    disabled: 'Disabled',
    hintAutoRenew: '(Auto renews 90 days when certificate is less than 30 days)',
    update: 'Update',
    save: 'Save',
    cancel: 'Cancel',
    forceRequestTitle: 'Request Certificate',
    forceRequestWarning: 'Current certificate validity is greater than 30 days, force re-apply?',
    forceRequestHint: 'This request will delete old certificate and generate new one',
    forceApply: 'Force Apply',
    logTitle: 'Running Logs',
    totalLogs: 'Total {count} logs',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    downloadAllLogs: 'Download All Logs',
    refreshNow: 'Refresh Now',
    clearLogs: 'Clear Logs',
    noLogs: 'No log records',
    close: 'Close',
  },
  acme: {
    title: 'ACME Certificate',
    domain: 'Domain',
    certificate: 'Certificate',
    privateKey: 'Private Key',
    issuer: 'Issuer',
    validFrom: 'Valid From',
    validTo: 'Valid To',
    autoRenew: 'Auto Renew',
    renew: 'Renew',
    renewSuccess: 'Renewal successful',
    renewFailed: 'Renewal failed',
    issueCert: 'Issue Certificate',
    deleteCert: 'Delete Certificate',
  },
  system: {
    title: 'System Settings',
    basicSettings: 'Basic Settings',
    securitySettings: 'Security Settings',
    networkSettings: 'Network Settings',
    backupSettings: 'Backup Settings',
    about: 'About',
    productName: 'Product Name',
    version: 'Version',
    currentVersion: 'Current Version',
    newVersion: 'New Version',
    checkUpdate: 'Check Update',
    noUpdate: 'Already latest version',
    downloadUpdate: 'Download Update',
    installUpdate: 'Install Update',
    systemInfo: 'System Info',
    platform: 'Platform',
    architecture: 'Architecture',
    operatingSystem: 'Operating System',
    webPort: 'Web Port',
    webHttpsPort: 'Web HTTPS Port',
    webdavPort: 'WebDAV Port',
    logLevel: 'Log Level',
    debug: 'Debug',
    info: 'Info',
    warn: 'Warn',
    error: 'Error',
    saveSettings: 'Save Settings',
    resetSettings: 'Reset Settings',
    settingsSaved: 'Settings saved',
    settingsReset: 'Settings reset',
    backupNow: 'Backup Now',
    restoreBackup: 'Restore Backup',
    backupSuccess: 'Backup successful',
    restoreSuccess: 'Restore successful',
    selectBackupFile: 'Select Backup File',
    loginRedirectPage: 'Login Redirect Page',
    systemLog: 'System Log',
    edit: 'Edit',
    webSettings: 'Web Settings (restart required)',
    httpPort: 'HTTP Port',
    httpStatus: 'HTTP Status',
    httpsPort: 'HTTPS Port',
    httpsStatus: 'HTTPS Status',
    certPath: 'Certificate Path',
    webdavSuffix: 'WebDAV Suffix',
    on: 'On',
    off: 'Off',
    noPasswordLogin: 'No Password Login (127.0.0.1)',
    currentStatus: 'Current Status',
    logSettings: 'Log Settings',
    logDays: 'Log Days',
    cacheSettings: 'Cache Settings',
    cacheAddress: 'Cache Address',
    cacheTime: 'Cache Time',
    deleteToRecycle: 'Delete to Recycle Bin',
    securityPath: 'Security Entry Path',
    path: 'Path',
    backupConfig: 'Backup Config',
    backupAllConfig: 'Backup All Config',
    backupCfgConfig: 'Backup Cfg Config',
    otherOperations: 'Other Operations',
    restartSoftware: 'Restart Software',
    homepage: 'Home',
    userConfig: 'User Config',
    fileList: 'File List',
    portMapping: 'Port Mapping',
    tunnelMgmt: 'Tunnel Management',
    dnsMgmt: 'DNS Management',
    userManagement: 'User Management',
    fileMgmt: 'File Management',
    editLoginRedirectPage: 'Edit Login Redirect Page',
    editWebSettings: 'Edit Web Settings',
    editNoPasswordLogin: 'Edit No Password Login',
    browse: 'Browse',
    noPasswordLoginStatus: 'No Password Login Status',
    editCacheSettings: 'Edit Cache Settings',
    editSecurityPath: 'Edit Security Path',
    editLogSettings: 'Edit Log Settings',
    close: 'Close',
  },
  transferServer: {
    title: 'Transfer Server Settings',
    localAsTransferServer: 'Local as Transfer Server Settings',
    asClientHint: 'As mapping client, no need to enable service, just select from the server list below.',
    asServerHint: 'As mapping server, private mode only allows key matching, public mode allows all devices',
    publicModeWarning: 'Public mode requires port forwarding, you can also set port range in settings',
    name: 'Name',
    attribute: 'Attribute',
    address: 'Address',
    port: 'Port',
    key: 'Key',
    secondAuth: 'Second Auth',
    maxConnections: 'Max Connections',
    mode: 'Mode',
    remark: 'Remark',
    operation: 'Operation',
    editConfig: 'Edit Config',
    none: 'None',
    availableServers: 'Available Transfer Servers',
    selectHint: 'Select for port mapping and p2p mapping.',
    forceCancelSelect: 'Force Cancel Select',
    viewLogs: 'View Logs',
    loading: 'Loading...',
    noData: 'No Data',
    newPort: 'New Port',
    p2pService: 'P2P Service',
    connectionsTotal: 'Connections/Total',
    notEnabled: 'Not Enabled',
    select: 'Select',
    deselect: 'Deselect',
    client: 'Client',
    server: 'Server',
    private: 'Private',
    public: 'Public',
  },
  distributionServer: {
    title: 'Distribution Server Settings',
    connectionServerSettings: 'Connection Distribution Server Settings',
    viewLogs: 'View Logs',
    address: 'Address',
    port: 'Port',
    key: 'Key',
    status: 'Status',
    operation: 'Operation',
    edit: 'Edit',
    enabled: 'Enabled',
    disabled: 'Disabled',
    start: 'Start',
    stop: 'Stop',
    running: 'Running',
    stopped: 'Stopped',
    restoreDefaults: 'Restore Defaults',
    confirmStart: 'Confirm to start connection server?',
    confirmStop: 'Confirm to stop connection server?',
    confirmRestore: 'Confirm to restore default settings?',
    distributionServerSettings: 'Distribution Server Settings',
    confirmStartDistribution: 'Confirm to start distribution server?',
    confirmStopDistribution: 'Confirm to stop distribution server?',
    portMappingSettings: 'Port Mapping Settings',
    portMappingHint: 'When mapping port is set to 0, port is auto-assigned by rules below',
    validPortRange: 'Valid Port Range',
    autoAssignStartPort: 'Auto Assign Start Port',
    editConnectionSettings: 'Edit Connection Server Settings',
    editDistributionSettings: 'Edit Distribution Server Settings',
    editPortMappingSettings: 'Edit Port Mapping Settings',
  },
  officialClient: {
    title: 'Control Server Settings',
    serverSettings: 'Server Settings',
    viewLogs: 'View Logs',
    serverAddress: 'Server Address',
    serverPort: 'Server Port',
    associatedUser: 'Associated User',
    status: 'Status',
    operation: 'Operation',
    edit: 'Edit',
    start: 'Start',
    stop: 'Stop',
    running: 'Running',
    stopped: 'Stopped',
    autoAssigned: 'Auto Assigned',
    mappingName: 'Name',
    internalAddress: 'Internal Address',
    internalPort: 'Internal Port',
    mappingPort: 'Mapping Port',
    protocol: 'Protocol',
    retry: 'Retry',
    autoMappingList: 'Auto Mapping List',
    addMapping: 'Add Mapping',
    delete: 'Delete',
    enable: 'Enable',
    disable: 'Disable',
    refresh: 'Refresh',
    noMapping: 'No Port Mapping',
    editClientConfig: 'Edit Client Config',
    serverAddressNotEditable: 'Server address is not editable',
    serverPortNotEditable: 'Server port is not editable',
    controlTokenNotEditable: 'Control token is not editable',
    controlToken: 'Control Token',
    enterUsername: 'Please enter username',
    enterControlToken: 'Please enter control token',
    addNewMapping: 'Add Mapping',
    editMapping: 'Edit Mapping',
    namePlaceholder: '5-15 characters',
    internalIpPlaceholder: '127.0.0.1',
    internalPortPlaceholder: '1-65535',
    mappingPortPlaceholder: '0 means auto-assign',
    autoAssignPort: '0 means auto-assign port',
    cancel: 'Cancel',
    confirm: 'Confirm',
    runningLogs: 'Running Logs',
    totalLogs: 'Total {count} logs',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    downloadAllLogs: 'Download All Logs',
    refreshNow: 'Refresh Now',
    clearLogs: 'Clear Logs',
    close: 'Close',
    noLogs: 'No Logs',
    confirmStopMapping: 'Are you sure to stop mapping "{name}"?',
    confirmStopClient: 'Are you sure to stop client connection? All mappings will be disconnected.',
    warning: 'Warning',
    usernameEmpty: 'Associated username is empty, continue?',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    usernameLabel: 'Associated User',
    nameLabel: 'Name',
    internalAddressLabel: 'Internal Address',
    internalPortLabel: 'Internal Port',
    mappingPortLabel: 'Mapping Port',
    protocolLabel: 'Protocol',
    tcp: 'TCP',
    udp: 'UDP',
    mappingSuccess: 'Mapping success (port:{port})',
    connected: 'Connected',
    notConnected: 'Not Connected',
    clientStarted: 'Client Started',
    clientStopped: 'Client Stopped',
    mappingAdded: 'Mapping Added',
    mappingUpdated: 'Mapping Updated',
    mappingStarted: 'Mapping Started',
    mappingStopped: 'Mapping Stopped',
    mappingSaveFailed: 'Failed to save mapping',
    mappingStartFailed: 'Failed to start mapping',
    mappingStopFailed: 'Failed to stop mapping',
    mappingDisabled: 'Disable',
    fetchFailed: 'Failed to fetch data',
    enterName: 'Please enter name',
    nameLengthError: 'Name must be 5-15 characters',
    enterInternalAddress: 'Please enter internal address',
    internalIpFormatError: 'Internal IP address format is incorrect',
    enterInternalPort: 'Please enter internal port',
    internalPortRangeError: 'Internal port range is 1-65535',
    enterMappingPort: 'Please enter mapping port',
    mappingPortRangeError: 'Mapping port range is 0-65535',
    selectProtocol: 'Please select protocol',
    refreshDataFailed: 'Failed to refresh data',
    refreshFailed: 'Refresh failed',
    saveFailed: 'Save failed',
    saveMappingFailed: 'Failed to save mapping',
    startMappingFailed: 'Failed to start mapping',
    started: 'Started',
    startFailed: 'Start failed',
    prompt: 'Prompt',
    stopMappingFailed: 'Failed to stop mapping',
    mappingStoppedMsg: 'Stopped',
    stopFailed: 'Stop failed',
    updateClientConfigFailed: 'Failed to update client config',
    clientConfigUpdated: 'Client config updated',
    updateFailed: 'Update failed',
    serverAddressRequired: 'Server address is required',
    serverPortRangeError: 'Server port range is 1-65535',
    controlTokenRequired: 'Control token is required',
    confirmStartClient: 'Are you sure to start client connection?',
    startClientFailed: 'Failed to start client',
    stopClientFailed: 'Failed to stop client',
    autoRefreshEnabled: 'Auto refresh enabled (5s/interval)',
    autoRefreshDisabled: 'Auto refresh disabled',
    fetchLogsFailed: 'Failed to fetch logs',
    fetchLogsError: 'Failed to fetch logs',
    confirmClearLogs: 'Are you sure to clear all port mapping logs?',
    clearLogsFailed: 'Failed to clear logs',
    logsCleared: 'Logs cleared',
    clearLogsError: 'Failed to clear logs',
    noLogsToDownload: 'No logs to download',
    downloadSuccess: 'All logs downloaded successfully, {count} records',
    downloadFailed: 'Failed to download logs',
    downloadError: 'Failed to download logs',
  },
  log: {
    title: 'Logs',
    viewLogs: 'View Logs',
    clearLogs: 'Clear Logs',
    downloadLogs: 'Download Logs',
    downloadAllLogs: 'Download All Logs',
    module: 'Module',
    level: 'Level',
    content: 'Content',
    time: 'Time',
    allLogs: 'All Logs',
    logTotal: 'Total {count} logs',
    autoRefresh: 'Auto Refresh',
    refreshInterval: 'Refresh Interval',
    second: 's',
    logCleared: 'Logs cleared',
    logDownloadSuccess: 'Logs downloaded successfully, {count} records',
    noLogs: 'No logs',
    confirmClear: 'Are you sure to clear all logs? This action cannot be undone!',
    clearFailed: 'Failed to clear logs',
    cleared: 'Logs cleared',
    autoRefreshEnabled: 'Auto refresh enabled',
    autoRefreshDisabled: 'Auto refresh disabled',
    fetchFailed: 'Failed to fetch logs',
    downloadFailed: 'Failed to download logs',
    noLogsToDownload: 'No logs to download',
    networkError: 'Network error',
  },
  collectList: {
    title: 'Favorites',
    totalItems: 'Total {count} items',
    filePath: 'File Path',
    collectTime: 'Collect Time',
    fileSize: 'File Size',
    collector: 'Collector',
    actions: 'Actions',
    delete: 'Delete',
    folder: 'Folder',
    deleted: 'Deleted',
    collectTimeLabel: 'Collect Time:',
    fileSizeLabel: 'File Size:',
    collectorLabel: 'Collector:',
    fetchFailed: 'Failed to fetch favorites list',
    pleaseLoginFirst: 'Please login first',
    objectDeleted: 'Object has been deleted',
    confirmDelete: 'Are you sure you want to delete favorite "{path}"?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deleteFailed: 'Failed to delete favorite',
    deleteSuccess: 'Favorite deleted successfully',
  },
  serverMapping: {
    title: 'Mapping Server',
    pleaseSelectTransferServer: 'Please select transfer server',
    description: 'Port mapping forwards internal host ports to external ports. When users access the external port, requests are automatically forwarded to the corresponding internal host port service.',
    mappingList: 'Port Mapping List',
    confirm: 'Confirm',
    deleteConfirm: 'Are you sure to delete mapping "{name}"?',
    cancelText: 'Cancel',
    viewLogs: 'View Logs',
    add: 'Add',
    stopAll: 'Stop All',
    restartAll: 'Restart All',
    refresh: 'Refresh',
    loading: 'Loading...',
    noMappingConfig: 'No port mapping configuration',
    name: 'Name',
    internalAddress: 'Internal Address',
    internalPort: 'Internal Port',
    mappingPort: 'Mapping Port',
    status: 'Status',
    operation: 'Operation',
    edit: 'Edit',
    start: 'Start',
    stop: 'Stop',
    delete: 'Delete',
    editMapping: 'Edit Port Mapping',
    addMapping: 'Add Port Mapping',
    namePlaceholder: '3-15 characters, numbers or letters only',
    internalIpPlaceholder: 'e.g: 127.0.0.1',
    internalPortPlaceholder: '1-65535',
    mappingPortPlaceholder: '0-65535',
    cancel: 'Cancel',
    save: 'Save',
    runningLogs: 'Running Logs',
    totalLogs: 'Total {count} logs',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    downloadAllLogs: 'Download All Logs',
    refreshNow: 'Refresh Now',
    clearLogs: 'Clear Logs',
    noLogs: 'No log records',
    close: 'Close',
    nameRequired: 'Please enter name',
    nameFormatError: 'Name must be 3-15 characters, numbers or letters only',
    ipRequired: 'Please enter internal IP address',
    ipFormatError: 'Please enter a valid IP address',
    internalPortRequired: 'Please enter internal port',
    internalPortRangeError: 'Port range is 1-65535',
    mappingPortRequired: 'Please enter mapping port',
    mappingPortRangeError: 'Port range is 0-65535',
    pleaseSelectServer: 'Please select server first',
    operationFailed: 'Operation failed',
    stopAllFailed: 'Failed to stop all mappings',
    stopAllSuccess: 'All mappings stopped',
    restartAllFailed: 'Failed to restart all mappings',
    restartAllSuccess: 'All mappings restarted',
    autoRefreshEnabled: 'Auto refresh enabled (5s/interval)',
    autoRefreshDisabled: 'Auto refresh disabled',
    fetchLogsFailed: 'Failed to fetch logs',
    fetchLogsError: 'Failed to fetch logs',
    confirmClearLogs: 'Are you sure to clear all port mapping logs?',
    clearLogsFailed: 'Failed to clear logs',
    logsCleared: 'Logs cleared',
    noLogsToDownload: 'No logs to download',
    downloadSuccess: 'All logs downloaded successfully, {count} records',
    downloadFailed: 'Failed to download logs',
    pleaseLoginFirst: 'Please login first',
  },
  p2pSetting: {
    title: 'P2P Client Settings (requires software restart)',
    viewLogs: 'View Logs',
    currentCount: 'Current Count',
    maxCount: 'Max Count',
    operation: 'Operation',
    update: 'Update',
    p2pServerSettings: 'P2P Server Settings',
    port: 'Port',
    enableRelay: 'Enable Relay',
    status: 'Status',
    running: 'Running',
    stopped: 'Stopped',
    stop: 'Stop',
    viewConnections: 'View Connections',
    updateAndStart: 'Update & Start',
    runningLogs: 'Running Logs',
    totalLogs: 'Total {count} logs',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    downloadAllLogs: 'Download All Logs',
    refreshNow: 'Refresh Now',
    clearLogs: 'Clear Logs',
    noLogs: 'No log records',
    close: 'Close',
    fetchConfigFailed: 'Failed to fetch configuration',
    countRequired: 'Count cannot be empty',
    countRangeError: 'Valid range is 1-1000',
    updateFailed: 'Update failed',
    updateSuccess: 'Update successful, restart software?',
    portRequired: 'Port cannot be empty',
    portRangeError: 'Port range is 1-65535',
    selectRelayStatus: 'Please select relay status',
    restartSoftware: 'Restart Software',
    restartSoftwareFailed: 'Failed to restart software',
    softwareWillRestart: 'Software will restart in 3 seconds',
    connectionLost: 'Connection lost, please refresh the page',
    autoRefreshEnabled: 'Auto refresh enabled (5s/interval)',
    autoRefreshDisabled: 'Auto refresh disabled',
    networkError: 'Network request failed',
    fetchLogsFailed: 'Failed to fetch logs',
    fetchLogsError: 'Failed to fetch logs: {error}',
    confirmClearLogs: 'Are you sure to clear all P2P logs?',
    clearLogsFailed: 'Failed to clear logs',
    logsCleared: 'Logs cleared',
    noLogsToDownload: 'No logs to download',
    downloadSuccess: 'All logs downloaded successfully, {count} records',
    downloadFailed: 'Failed to download logs: {error}',
    pleaseLoginFirst: 'Please login first',
  },
  proxyMgmt: {
    title: 'Forward Proxy Server',
    viewLogs: 'View Logs',
    description: 'Forward proxy is an intermediate server between clients (such as user browsers) and the internet. It sends requests to external servers on behalf of clients, and servers do not know the actual client making the request.',
    socks5Proxy: 'SOCKS5 Proxy',
    httpsProxy: 'HTTPS Proxy',
    editConfig: 'Edit Config',
    ipAddress: 'IP Address',
    port: 'Port',
    username: 'Username',
    password: 'Password',
    status: 'Status',
    operation: 'Operation',
    stop: 'Stop',
    start: 'Start',
    noAuth: 'No Auth',
    noPassword: 'No Password',
    notRunning: 'Not Running',
    running: 'Running',
    stopped: 'Stopped',
    error: 'Error',
    notConnected: 'Not Connected',
    success: 'Success',
    editProxyConfig: 'Edit {type} Proxy Config',
    ipPlaceholder: 'e.g: 0.0.0.0',
    portPlaceholder: '1-65535',
    usernamePlaceholder: 'Leave empty for no authentication',
    passwordPlaceholder: 'Leave empty for no authentication',
    cancel: 'Cancel',
    save: 'Save',
    runningLogs: 'Running Logs',
    totalLogs: 'Total {count} logs',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    downloadAllLogs: 'Download All Logs',
    refreshNow: 'Refresh Now',
    clearLogs: 'Clear Logs',
    noLogs: 'No log records',
    close: 'Close',
    ipRequired: 'Please enter IP address',
    ipFormatError: 'Please enter a valid IP address',
    portRequired: 'Please enter port',
    portRangeError: 'Port range is 1-65535',
    usernameFormatError: 'Username must be 0-15 characters, numbers or letters only',
    passwordFormatError: 'Password must be 0-64 characters, numbers or letters only',
    confirmDiscard: 'Are you sure you want to discard changes?',
    confirm: 'Confirm',
    cancelText: 'Cancel',
    operationFailed: 'Operation failed',
    configUpdateSuccess: 'Configuration updated successfully',
    configUpdateFailed: 'Configuration update failed: {error}',
    startSuccess: '{type} proxy started successfully',
    stopSuccess: '{type} proxy stopped successfully',
    startFailed: 'Failed to start {type} proxy: {error}',
    stopFailed: 'Failed to stop {type} proxy: {error}',
    autoRefreshEnabled: 'Auto refresh enabled (5s/interval)',
    autoRefreshDisabled: 'Auto refresh disabled',
    networkError: 'Network request failed',
    fetchLogsFailed: 'Failed to fetch logs',
    fetchLogsError: 'Failed to fetch logs: {error}',
    confirmClearLogs: 'Are you sure to clear all {type} proxy logs?',
    clearLogsFailed: 'Failed to clear logs',
    logsCleared: 'Logs cleared',
    noLogsToDownload: 'No logs to download',
    downloadSuccess: 'All logs downloaded successfully, {count} records',
    downloadFailed: 'Failed to download logs: {error}',
    pleaseLoginFirst: 'Please login first',
  },
  reverseProxy: {
    title: 'Reverse Proxy Server',
    description: 'Reverse proxy forwards external requests (supports IPv4 and IPv6) to specific ports on internal servers. In proxy server mode, clients are unaware of the actual server providing the service.',
    proxyList: 'Reverse Proxy List',
    viewLogs: 'View Logs',
    add: 'Add',
    refresh: 'Refresh',
    loading: 'Loading...',
    noProxyConfig: 'No reverse proxy configuration',
    name: 'Name',
    internalAddress: 'Internal Address',
    internalPort: 'Internal Port',
    mappingPort: 'Mapping Port',
    protocol: 'Protocol',
    status: 'Status',
    operation: 'Operation',
    stop: 'Stop',
    start: 'Start',
    edit: 'Edit',
    delete: 'Delete',
    addProxy: 'Add Reverse Proxy',
    editProxy: 'Edit Reverse Proxy',
    namePlaceholder: '3-15 characters, numbers or letters only',
    internalIpPlaceholder: 'e.g: 127.0.0.1',
    internalPortPlaceholder: '1-65535',
    mappingPortPlaceholder: '0-65535',
    cancel: 'Cancel',
    save: 'Save',
    runningLogs: 'Running Logs',
    totalLogs: 'Total {count} logs',
    autoRefresh: 'Auto Refresh',
    refreshInterval: '(5s)',
    downloadAllLogs: 'Download All Logs',
    refreshNow: 'Refresh Now',
    clearLogs: 'Clear Logs',
    noLogs: 'No log records',
    close: 'Close',
    nameRequired: 'Please enter name',
    nameFormatError: 'Name must be 3-15 characters, numbers or letters only',
    ipRequired: 'Please enter internal IP address',
    ipFormatError: 'Please enter a valid IP address',
    internalPortRequired: 'Please enter internal port',
    internalPortRangeError: 'Port range is 1-65535',
    mappingPortRequired: 'Please enter mapping port',
    mappingPortRangeError: 'Port range is 0-65535',
    protocolRequired: 'Please select protocol',
    pleaseStopFirst: 'Please stop the proxy before editing',
    confirmDiscard: 'Are you sure you want to discard changes?',
    confirm: 'Confirm',
    cancelText: 'Cancel',
    operationFailed: 'Operation failed',
    operationSuccess: 'Operation successful',
    startSuccess: 'Proxy started successfully',
    startFailed: 'Failed to start proxy',
    stopSuccess: 'Proxy stopped successfully',
    stopFailed: 'Failed to stop proxy',
    deleteSuccess: 'Proxy deleted successfully',
    deleteFailed: 'Failed to delete proxy',
    deleteConfirm: 'Are you sure you want to delete this proxy?',
    autoRefreshEnabled: 'Auto refresh enabled (5s/interval)',
    autoRefreshDisabled: 'Auto refresh disabled',
    networkError: 'Network request failed',
    fetchLogsFailed: 'Failed to fetch logs',
    fetchLogsError: 'Failed to fetch logs: {error}',
    confirmClearLogs: 'Are you sure to clear all reverse proxy logs?',
    clearLogsFailed: 'Failed to clear logs',
    logsCleared: 'Logs cleared',
    noLogsToDownload: 'No logs to download',
    downloadSuccess: 'All logs downloaded successfully, {count} records',
    downloadFailed: 'Failed to download logs: {error}',
    pleaseLoginFirst: 'Please login first',
    fetchDataFailed: 'Failed to fetch data',
  },
  about: {
    title: 'About',
    productName: 'Product Name',
    version: 'Version',
    description: 'Description',
    officialWebsite: 'Official Website',
    documentation: 'Documentation',
    support: 'Support',
    license: 'License',
    copyright: 'Copyright',
    basicInfo: 'Basic Information',
    userManual: 'User Manual',
    appManual: 'APP Manual',
    csdnBlog: 'CSDN Blog',
    bilibiliVideo: 'Bilibili Video',
    versionAddress: 'Version Address',
    officialDownload: 'Official Download',
    weiyunDownload: 'Weiyun Download',
    otherAccess: 'Other Access Methods',
    contactEmail: 'Contact Email',
    qqGroup: 'QQ Group',
    officialWebsite2: 'Official Website',
    clickToView: 'Click to View',
    featureInfo: 'Feature Information',
    passwordReset: 'Password Reset',
    disclaimer: 'Disclaimer',
    updateLog: 'Update Log',
    osLabel: 'Operating System',
    unknown: 'Unknown',
    ipv6HttpAddress: 'IPv6 HTTP Address',
    ipv6HttpsAddress: 'IPv6 HTTPS Address',
    enabled: 'Enabled',
    notEnabled: 'Not Enabled',
    notDetected: 'IPv6 address not detected',
    httpServiceNotEnabled: 'HTTP service not enabled',
    httpsServiceNotEnabled: 'HTTPS service not enabled',
    visit: 'Visit',
    copy: 'Copy',
    close: 'Close',
    fetchSystemInfoFailed: 'Failed to fetch system info',
    networkError: 'Network error, please check connection',
    noContentToCopy: 'No content to copy',
    copySuccess: 'Copied successfully',
    invalidUrl: 'Invalid URL',
    feature1: 'Supports user login (username: admin, default password: tf12345678), 127.0.0.1 localhost access will skip password',
    feature2: 'Supports Webdav(/tfdav) file management (HTTPS and HTTP), share local files from anywhere',
    feature3: 'Supports mounting Windows local webdav service, access remote mounted drives like C: drive',
    feature4: 'Supports browser-based local file management (HTTPS and HTTP), supports online preview of common files, videos, documents and PDFs',
    feature5: 'Supports file sharing management (with expiry, password and upload restrictions)',
    feature6: 'Supports public network (e.g. Alibaba Cloud, local public IP) port mapping',
    feature7: 'Supports P2P port mapping (based on TCP protocol)',
    feature8: 'Supports HTTP proxy and SOCKS5 proxy (username and password are optional)',
    feature9: 'Supports syncing local files & folders to another tfcenter device',
    feature10: 'Supports Alibaba Cloud and Pubyun(3322) DDNS',
    feature11: 'Supports tfcenter APP access to server (photo sync, video playback, share to WeChat & QQ, etc.)',
    feature12: 'Supports CentOS 7/8, Ubuntu 18/20/22, Windows 10/11, ARM systems, Raspberry Pi, etc.',
    feature13: 'Supports Chinese/English language switch',
    feature14: 'Supports SMB server file sharing',
    passwordResetLinux: 'Linux: use -reset admin parameter to reset admin password to tf12345678',
    passwordResetWindows: 'Windows: modify tfcenter.cfg loAuthLogin parameter to true to enable localhost password-free login',
    disclaimer1: 'This software is free of charge.',
    disclaimer2: 'This software is completely harmless and contains no malicious code, but does not guarantee any third-party modified versions.',
    disclaimer3: 'This software does not collect user privacy data.',
    log420item1: 'Added module management, can disable and enable module web display',
    log420item2: 'Fixed relay server domain name issue',
    log420item3: 'Fixed Cloudflare DDNS  prefix Bad Request error',
    log420item4: 'Added Chinese/English language switch support',
    log420item5: 'Added SMB server function',
    log420item6: 'Current version does not support Windows 7 and below. For such needs, please use v4.1 or earlier versions',
    log411item1: 'Supports modifying web certificate path (certificate files named cert.pem and priv.key)',
    log411item2: 'Supports ACME auto certificate application (supports Alibaba Cloud auto application), stored in current certs directory',
    log411item3: 'Supports modifying webdav suffix via settings (default is tfdav)',
    log411item4: 'Added view logs function on each page',
    log411item5: 'Fixed expiry error when sharing',
    log411item6: 'Fixed device center device deletion failure',
    log411item7: 'Fixed status display error during file search',
    log410item1: 'Optimized sync management for mobile display',
    log410item2: 'Added device center management, can manage other tfcenter device addresses',
    log403item1: 'Added macOS support',
    log403item2: 'Added manual directory input for directory selection',
    log403item3: 'Fixed Windows multi-select root directory C: D: error',
    log402item1: 'Changed left and top navigation to draggable mode to avoid blocking buttons',
    log402item2: 'Fixed Alibaba Cloud DDNS not supporting  and * prefix',
    log402item3: 'Fixed mount page PID matching issue',
    log402item4: 'Disabled normal users from accessing homepage resource info',
    log401item1: 'Modified Windows console, added foreground interface showing operation buttons and corresponding startup info',
    log401item2: 'Fixed some display issues',
    log400item1: 'Adjusted page style',
    log400item2: 'Added reverse proxy function',
    log400item3: 'Added config file stored in BoltDB database',
    log400item4: 'Added setting to specify login redirect page',
    log400item5: 'Added auto login function',
    log400item6: 'Embedded Windows Webdav service mount',
    log400item7: 'Added control server function',
    log400item8: 'Added other access methods (viewable in About)',
    log342item1: 'Cancelled Windows daemon startup to avoid certain OS generating many processes',
    log342item2: 'Updated tfcenter-daemon.bat script, set service to auto-restart on exit',
    log341item1: 'Implemented program daemon startup, removed Windows and Linux tfcenter-daemon program',
    log341item2: 'Port mapping server abnormal exit: client reconnects once -> keeps reconnecting',
    log341item3: 'Fixed port mapping client abnormal exit probability selecting server failure',
    log341item4: 'Fixed some Android phones running failure (filesync permission issue)',
  },
}
